import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isAxiosError } from 'axios';

/** Hooks */
import { useAuth0 } from '@auth0/auth0-react';
import { useGetMySDKUser } from '@/hooks';
import { useIntercomMessenger } from '@/hooks/useIntercomMessenger';

/** Components */
import { LoginPage } from '@/pages/LoginPage';
import { TrblToast } from '@/components/Shared/TrblToast';

/** Utils */
import { setAxiosInterceptors } from './utils';

/** Clients */
import adminAxiosClient from '@/apis/admin-api/axios';
import tassAxiosClient from '@/apis/tass-api/axios';
import stapiAxiosClient from '@/apis/stapi-api/axios';

/** Components */
import { TermsAndConditionsWrapper } from '@/components/TermsAndConditions/TermsAndConditionsWrapper';

export const PageWrapper = () => {
  const [isAxiosConfigured, setIsAxiosConfigured] = useState(false);

  const { isAuthenticated, isLoading: isLoadingAuth, getAccessTokenSilently, logout } = useAuth0();

  const { data: sdkUser, error: sdkUserError } = useGetMySDKUser();
  const navigate = useNavigate();
  useIntercomMessenger(sdkUser?.id, isAxiosConfigured && isAuthenticated);
  useEffect(() => {
    if (isAxiosError(sdkUserError) && sdkUserError.response?.status === 404) {
      navigate('/no-access');
    }
  }, [sdkUserError, navigate]);

  useEffect(() => {
    if (sdkUser && sdkUser.isEnabled === false) {
      navigate('/no-access');
    }
  }, [sdkUser, navigate]);

  useEffect(() => {
    setAxiosInterceptors([adminAxiosClient, tassAxiosClient, stapiAxiosClient], getAccessTokenSilently, logout);

    setIsAxiosConfigured(true);
  }, []);

  // We wait for the user to be authenticated and if he is, also wait for the user data to be fetched and axios configured
  const isLoading = isLoadingAuth || (!isAxiosConfigured && isAuthenticated);

  return (
    <main>
      {!isLoading ? (
        <>
          {isAuthenticated ? (
            <>
              <TermsAndConditionsWrapper>
                <Outlet />
              </TermsAndConditionsWrapper>
              <TrblToast />
            </>
          ) : (
            <LoginPage />
          )}
        </>
      ) : (
        <div></div>
      )}
    </main>
  );
};
